import { render } from "./CardTwentyEight.vue?vue&type=template&id=db95cf92"
import script from "./CardTwentyEight.vue?vue&type=script&lang=js"
export * from "./CardTwentyEight.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__